import publicConfig from "../public-config.js";

import { request as httpRequest } from "./http-library.js";

const ssoHost = publicConfig.external_address;

export const Session = {
  destroy: function destroySession(token, callback) {
    const request_params = {
      host: ssoHost,
      path: "/v2/auth/logout",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    httpRequest(request_params, function (response) {
      callback(response);
    });
  },
};
